import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{
    selectedSalesTermIds: string[];
}>;

export const DispatchToggleSelectedSalesTerms: HandlerType = props => {
    props.dispatch({
        type: "Custom/Terms/SelectedTermIdsForSales",
        selectedSalesTermIds: props.parameter.selectedSalesTermIds,
    });
};

export const chain = [DispatchToggleSelectedSalesTerms];

const selectSalesTerms = createHandlerChainRunner(chain, "SelectedSalesTerms");
export default selectSalesTerms;
